import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { Flex, Label } from 'rebass';
import { connect } from 'react-redux';
import { PvBox } from 'styles/CustomComponents';
import { PvSelect } from 'components/form/PvSelect';
import { PvInput } from "../../styles/CustomComponents";
import { PvCheckbox } from "../../components/form/PvCheckbox";
import {
  examClassesToDropdown,
  lessonTypes,
  getLabel,
} from "../../util/SearchUtil";

class LessonsEditSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datePickerOpen: false
    };
  }

  render() {

    const {
      examClasses,
      loading,
      searchTerms,
      updateSearchTerms
    } = this.props;

    return (
      <PvBox my={3}>
        <Flex flexWrap="wrap" alignItems="flex-end">
          <PvBox mb={[0, 0, 3]} w={[1, 1, 1]}>
            <PvBox display="inline-block" px={2} w={[3 / 4, 1 / 2, 1 / 4]}>
              <Label mb={2}>
                <Translate value="datatable.lesson_description" />
              </Label>
              <PvInput
                name="lessonDescription"
                onChange={(e) =>
                  updateSearchTerms({ description: e.target.value })
                }
                value={this.props.searchTerms.description || ""}
              />
            </PvBox>
            <PvBox minWidth="19em" display="inline-block" px={2} pb={3}>
              <Label mb={2}>
                <Translate value="search.exam_class" />
              </Label>
              <PvSelect
                placeholder=""
                options={examClassesToDropdown(examClasses)}
                value={{
                  value: searchTerms.examClass,
                  label: searchTerms.examClass,
                }}
                onChange={(option) =>
                  updateSearchTerms({ examClass: option.value })
                }
                isLoading={loading}
                addEmpty={true}
              />
            </PvBox>
            <PvBox minWidth="19em" display="inline-block" px={2} pb={3}>
              <Label mb={2}>
                <Translate value="datatable.lesson_type" />
              </Label>
              <PvSelect
                placeholder=""
                options={lessonTypes()}
                value={{
                  value: searchTerms.lessonType,
                  label: getLabel(searchTerms.lessonType, lessonTypes()),
                }}
                onChange={(option) =>
                  updateSearchTerms({ lessonType: option.value })
                }
                isLoading={loading}
                addEmpty={true}
              />
            </PvBox>
          </PvBox>
          <PvBox mb={[0, 0, 3]} w={[1, 1, 1]}>
            <PvBox display="inline-block" px={2} pb={3} w={[1, 1 / 2, 1 / 4]}>
              <Label mb={2}>
                <PvCheckbox
                  type="checkbox"
                  defaultChecked={searchTerms.requiredForIndependentTraining}
                  onChange={(e) => {
                    updateSearchTerms({
                      requiredForIndependentTraining: e.target.checked
                        ? true
                        : undefined,
                    });
                  }}
                />
                <Translate
                  style={{ paddingLeft: "1em" }}
                  value="datatable.independent_training"
                />
              </Label>
            </PvBox>
            <PvBox display="inline-block" px={2} pb={3} w={[1, 1 / 2, 1 / 4]}>
              <Label mb={2}>
                <PvCheckbox
                  type="checkbox"
                  defaultChecked={searchTerms.requiredForPersonTransport}
                  onChange={(e) => {
                    updateSearchTerms({
                      requiredForPersonTransport: e.target.checked
                        ? true
                        : undefined,
                    });
                  }}
                />
                <Translate
                  style={{ paddingLeft: "1em" }}
                  value="datatable.person_transport"
                />
              </Label>
            </PvBox>
          </PvBox>
        </Flex>
      </PvBox>
    );
  }
}

LessonsEditSearch.propTypes = {
  loading: PropTypes.bool,
  searchTerms: PropTypes.object,
  updateSearchTerms: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
    examClasses: state.general.examClasses,
    loading: state.general.loading,
  };
};

export default connect(
  mapStateToProps
)(LessonsEditSearch);



// WEBPACK FOOTER //
// ./src/containers/search/LessonsEditSearch.jsx